import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { LicenseInfo } from '@mui/x-license'

import App from './App'
import { scrubSentryBreadcrumb, scrubSentryEvent } from './utils/sentryScrub'

// Initialize Sentry error monitoring (no-op if DSN is not set)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
    // No request bodies, cookies, headers or IP addresses (ISO #1735 15.5).
    sendDefaultPii: false,
    beforeSend: (event) => scrubSentryEvent(event),
    beforeSendTransaction: (event) => scrubSentryEvent(event),
    beforeBreadcrumb: (crumb) => scrubSentryBreadcrumb(crumb),
  })
}

// Configure MUI X Pro license
LicenseInfo.setLicenseKey('3b7d7ceccb05b66d64e5bbcac7c83f84Tz05OTU4MSxFPTE3NjAwMTc5MDkwMDAsUz1wcm8sTE09cGVycGV0dWFsLFBWPVEzLTIwMjQsS1Y9Mg==')

const render = () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    <>
      <App />
    </>
  )
}

render()